import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db, functions } from "./firebaseConfig";
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  state: {
    user: null,
    user_doc: null,
    manager: null,
    accounts: {
      primary: null,
      managers: [],
    },
    forms: [],
    plans: [],
    visible_plans: [],
    plan_id: null,
    departments: {},
    locations: {},
  },
  getters: {
    getUser: (state) => {
      return state.user;
    },
    getUserDoc: (state) => {
      return state.user_doc;
    },
    getPlans: (state) => {
      return [].concat(state.plans, state.visible_plans);
    },
    getForms: (state) => {
      return state.forms;
    },
    getPlanById: (state) => {
      return (
        state.plans.find((p) => p.id == state.plan_id) ||
        state.visible_plans.find((p) => p.id == state.plan_id)
      );
    },
  },
  mutations: {
    ...vuexfireMutations,
    setUser(state, user) {
      state.user = user;
    },
    setPlanId: (state, plan_id) => {
      state.plan_id = plan_id;
    },
    clearUser(state) {
      state.user = null;
      state.user_doc = null;
      state.manager = null;
      state.accounts = {
        primary: null,
        managers: [],
      };
    },
    get_visible_plans(state) {
      if (this.get_visible_plans) {
        this.get_visible_plans();
      }
      this.get_visible_plans = db
        .collection("plan")
        .where("visible", "==", false)
        .where("active", "==", true)
        .where("visible_by", "array-contains", state.user_doc.id)
        .onSnapshot((querySnapshot) => {
          state.visible_plans = querySnapshot.docs.map((d) =>
            Object.assign({ id: d.id }, d.data())
          );
        });
    },
  },
  actions: {
    async getUserDoc(context, uid) {
      const getManager = functions.httpsCallable("getManagerAccounts");
      let accounts = await (await getManager({})).data;
      context.state.accounts = accounts;
      console.log(accounts);
      if (accounts.primary && !accounts.managers.length) {
        return context.dispatch("setManager", -1);
      } else if (!accounts.primary && accounts.managers.length == 1) {
        return context.dispatch("setManager", 0);
      }
    },
    setManager: firestoreAction(function(context, account_index) {
      if (this.clearManager) {
        this.clearManager();
        delete this.clearManager;
      }
      context.state.manager = null;
      if (account_index === -1) {
        return context.dispatch(
          "setUserDoc",
          context.state.accounts.primary.id
        );
      } else {
        const selectedManager = context.state.accounts.managers[account_index];
        this.clearManager = db
          .doc(selectedManager.path)
          .onSnapshot((document) => {
            context.state.manager = Object.assign(document.data(), {
              id: document.id,
              index: account_index,
              path: document.path,
            });
          });
        return context.dispatch("setUserDoc", selectedManager.user_doc.id);
      }
    }),
    setUserDoc: firestoreAction(function(context, uid) {
      return context
        .bindFirestoreRef("user_doc", db.collection("user").doc(uid))
        .then((user) => {
          return Promise.all([
            context.dispatch("setDepartments", uid),
            context.dispatch("setLocations", uid),
          ]);
        });
    }),
    setDepartments: firestoreAction(function(context, uid) {
      if (this.resetDepartments) {
        this.resetDepartments();
        context.state.departments = {};
      }
      this.resetDepartments = db
        .collection(`user/${uid}/departments`)
        .onSnapshot((query) => {
          let allowed = {};
          if (context.state.manager) {
            context.state.manager.departments.forEach(
              (i) => (allowed[i] = true)
            );
          }
          query.docs.forEach((d) => {
            if (
              !context.state.manager ||
              (Object.keys(allowed).length && allowed[d.id])
            )
              context.state.departments[d.id] = Object.assign(
                { id: d.id },
                d.data()
              );
          });
        });
    }),
    setLocations: firestoreAction(function(context, uid) {
      if (this.resetLocations) {
        this.resetLocations();
        context.state.locations = {};
      }
      this.resetLocations = db
        .collection(`user/${uid}/locations`)
        .onSnapshot((query) => {
          let allowed = {};
          if (context.state.manager) {
            context.state.manager.locations.forEach((i) => (allowed[i] = true));
          }
          query.docs.forEach((d) => {
            if (
              !context.state.manager ||
              (Object.keys(allowed).length && allowed[d.id])
            )
              context.state.locations[d.id] = Object.assign(
                { id: d.id },
                d.data()
              );
          });
        });
    }),
    setPlans: firestoreAction(async (context) => {
      if (context.state.user_doc) {
        await context.commit("get_visible_plans");
      }
      return context.bindFirestoreRef(
        "plans",
        db
          .collection("plan")
          .where("visible", "==", true)
          .orderBy("display_order")
      );
    }),
    setForms(context) {
      if (this.resetForms) {
        this.resetForms();
        context.state.forms = [];
      }
      this.resetForms = db
        .collection(`user/${context.state.user_doc.id}/forms`)
        .orderBy("title")
        .onSnapshot((query) => {
          context.state.forms = query.docs.map((d) =>
            Object.assign({ id: d.id }, d.data())
          );
        });
    },
    signOut(context) {
      context.commit("clearUser");
    },
  },
});
